import i18n, { TOptions } from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { sv } from './locales/sv'
import { en } from './locales/en'
import { ILanguage } from '../interfaces/ILanguage'
import dayjs from 'dayjs'
import 'dayjs/locale/sv'
import 'dayjs/locale/en'

i18n
   // detect user language
   // learn more: https://github.com/i18next/i18next-browser-languageDetector
   .use(LanguageDetector)
   // pass the i18n instance to react-i18next.
   .use(initReactI18next)
   // init i18next
   // for all options read: https://www.i18next.com/overview/configuration-options
   .init({
      debug: true,
      lng: 'sv',
      fallbackLng: 'sv',
      interpolation: {
         escapeValue: false, // not needed for react as it escapes by default
      },
      resources: {
         en: {
            translation: en,
         },
         sv: {
            translation: sv,
         },
      },
   })

dayjs.locale(i18n.language)
i18n.on('languageChanged', (lng) => {
   dayjs.locale(lng)
})

export default i18n

type TranslationKey = keyof ILanguage

export const t = (key: TranslationKey, options?: TOptions): string => {
   return i18n.t(key, options)
}
